import { render, staticRenderFns } from "./truenas.vue?vue&type=template&id=45b55224&scoped=true&"
import script from "./truenas.vue?vue&type=script&lang=js&"
export * from "./truenas.vue?vue&type=script&lang=js&"
import style0 from "./truenas.vue?vue&type=style&index=0&id=45b55224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b55224",
  null
  
)

export default component.exports